import { useTokens } from '../../shared/theme';
import { Button } from '../../shared/uiKit';
import StateScreen from '../StateScreen';

/**
 * retryable-outage state (5xx / network / 429). Warm and reassuring. An outage
 * must NEVER look like a deleted account (so this is distinct from
 * find-your-school). Offers a Retry that re-runs the branding fetch.
 *
 * @param {{ onRetry?: () => void }} props
 */
export default function OutageState({ onRetry }) {
  const t = useTokens();
  return (
    <StateScreen>
      <h1
        className="text-[30px] leading-tight mb-2"
        style={{ fontFamily: t.fonts.display, fontWeight: 500, color: t.heading }}
      >
        We can&apos;t reach Coffee Chats right now
      </h1>
      <p className="text-base mb-5" style={{ color: t.muted, fontFamily: t.fonts.body }}>
        This is on our side, not yours. Your school&apos;s portal is still here. Give it a moment and
        try again.
      </p>
      <div>
        <Button label="Retry" onClick={onRetry} />
      </div>
    </StateScreen>
  );
}
